<script setup lang="ts">
import FullscreenLoader from '@/components/FullscreenLoader.vue'

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  titleAction: {
    type: Boolean,
    default: false,
  },
  confirmBtnText: {
    type: String,
    default: 'Confirm',
  },
  cancelBtnText: {
    type: String,
    default: 'Cancel',
  },
  onConfirm: {
    type: Function,
  },
  onCancel: {
    type: Function,
  },
  isDialogVisible: {
    type: Boolean,
    required: true,
  },
  showActions: {
    type: Boolean,
    default: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  height: {
    type: String,
    default: 'auto',
  },
  cardPaddingClasses: {
    type: String,
    default: '',
  },
  confBtnProps: {
    type: Object,
    default: () => ({}),
  },
})
const emit = defineEmits([
  'update:modelValue',
  'submit',
  'update:isDialogVisible',
  'close',
])

const updateDialogModelValue = (val: boolean) => {
  emit('update:isDialogVisible', val)
}
const closeButtonClicked = () => {
  emit('update:isDialogVisible', false)
  emit('close')
}
const cancel = () => {
  updateDialogModelValue(false)
  props.onCancel && props.onCancel()
}
const confirm = () => {
  updateDialogModelValue(false)
  props.onConfirm && props.onConfirm()
}
</script>

<template>
  <VDialog
    v-bind="$attrs"
    :content-props="{ id: 'popup-modal' }"
    :model-value="isDialogVisible"
    @update:model-value="updateDialogModelValue"
  >
    <VCard :height="height" :class="cardPaddingClasses || 'pa-0'">
      <VCardTitle class="popup-title gilroy-bold">
        <div
          class="w-100 pa-1"
          :class="{
            'text-start': !titleAction,
            'd-flex justify-space-between align-center': true,
          }"
        >
          <span style="text-align: start" class="d-flex flex-row align-center">
            {{ title }}
            <slot name="action-with-title" />
          </span>
          <span class="ml-auto">
            <slot name="title-action" />
            <VBtn
              variant="text"
              elevation="0"
              class="cursor-pointer zoom-on-hover"
              icon="tabler-x"
              @click="closeButtonClicked"
            />
          </span>
        </div>
      </VCardTitle>
      <VCardText>
        <slot name="body" />
      </VCardText>
      <VSpacer />
      <div
        v-if="showActions"
        style="margin-top: 16px"
        class="d-flex justify-center gap-4"
      >
        <VBtn
          width="100px"
          color="primary"
          elevation="0"
          variant="outlined"
          :style="{
            backgroundColor: `var(--v-textfields-bg)`,
          }"
          @click="cancel"
        >
          {{ cancelBtnText }}
        </VBtn>
        <VBtn
          v-bind="confBtnProps"
          width="130px"
          elevation="0"
          @click="confirm"
        >
          <span
            :style="{
              color: `rgb(var(--v-theme-${confBtnProps.color || 'secondary'}))`,
            }"
          >
            {{ confirmBtnText }}
          </span>
        </VBtn>
      </div>
      <VCardActions>
        <slot name="actions" />
      </VCardActions>
    </VCard>
    <FullscreenLoader v-if="loading" text="" />
  </VDialog>
</template>
<style scoped>
.popup-title {
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: bold;
  line-height: 120%; /* 21.6px */
}
</style>
